import PasswordSetupStep from './PasswordSetupStep';

export default PasswordSetupStep;
